import API from "@/api";

export const moduleName = "auctionBanner";

export const actionTypes = {
  ACTION_LOAD_AUCTION_BANNERS: "ACTION_LOAD_AUCTION_BANNERS",
  ACTION_ADD_AUCTION_BANNER: "ACTION_ADD_AUCTION_BANNER",
  ACTION_EDIT_AUCTION_BANNER: "ACTION_EDIT_AUCTION_BANNER",
  ACTION_DELETE_AUCTION_BANNER: "ACTION_DELETE_AUCTION_BANNER"
};

export const getterTypes = {
  GETTER_AUCTION_BANNERS: "GETTER_AUCTION_BANNERS",
  GETTER_AUCTION_BANNERS_COUNT: "GETTER_AUCTION_BANNERS_COUNT"
};

export const mutationTypes = {
  SET_AUCTION_BANNERS_DATA: "SET_AUCTION_BANNERS_DATA",
  SET_AUCTION_BANNER: "SET_AUCTION_BANNER",
  UPDATE_AUNCTION_BANNER: "UPDATE_AUNCTION_BANNER",
  DELETE_AUNCTION_BANNER: "DELETE_AUNCTION_BANNER"
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    auctionBanners: [],
    auctionBannersCount: 0
  }),

  actions: {
    async [actionTypes.ACTION_LOAD_AUCTION_BANNERS]({ commit }, payload) {
      const response = await API.auctionBannerManager.loadAuctionBanners(
        payload
      );
      const { auctionBanners, count } = response.data;
      commit(mutationTypes.SET_AUCTION_BANNERS_DATA, [auctionBanners, count]);
    },
    async [actionTypes.ACTION_ADD_AUCTION_BANNER]({ commit }, payload) {
      const {
        data: auctionBanner
      } = await API.auctionBannerManager.addAuctionBanner(payload);
      commit(mutationTypes.SET_AUCTION_BANNER, auctionBanner);
    },
    async [actionTypes.ACTION_EDIT_AUCTION_BANNER](
      { commit },
      { auctionBannerId, auctionBanner }
    ) {
      const { data } = await API.auctionBannerManager.editAuctionBanner(
        auctionBannerId,
        auctionBanner
      );
      commit(mutationTypes.UPDATE_AUNCTION_BANNER, data);
    },
    async [actionTypes.ACTION_DELETE_AUCTION_BANNER](
      { commit },
      { auctionBannerId }
    ) {
      await API.auctionBannerManager.deleteAuctionBanner(auctionBannerId);
      commit(mutationTypes.DELETE_AUNCTION_BANNER, auctionBannerId);
    }
  },

  mutations: {
    [mutationTypes.SET_AUCTION_BANNERS_DATA](
      state,
      [auctionBanners, auctionBannersCount]
    ) {
      if (Array.isArray(auctionBanners)) {
        state.auctionBanners = auctionBanners;
      }
      if (!isNaN(auctionBannersCount)) {
        state.auctionBannersCount = auctionBannersCount;
      }
    },
    [mutationTypes.SET_AUCTION_BANNER](state, auctionBanner) {
      // state.auctionBanners.pop();
      state.auctionBanners.unshift(auctionBanner);
      state.auctionBannersCount++;
    },
    [mutationTypes.UPDATE_AUNCTION_BANNER](state, auctionBanner) {
      const index = state.auctionBanners.findIndex(
        b => b.id === auctionBanner.id
      );
      if (index === -1) return;
      state.auctionBanners.splice(index, 1, auctionBanner);
    },
    [mutationTypes.DELETE_AUNCTION_BANNER](state, auctionBannerId) {
      const index = state.auctionBanners.findIndex(
        b => b.id === auctionBannerId
      );
      if (index === -1) return;
      state.auctionBanners.splice(index, 1);
    }
  },

  getters: {
    [getterTypes.GETTER_AUCTION_BANNERS]: state => state.auctionBanners,
    [getterTypes.GETTER_AUCTION_BANNERS_COUNT]: state =>
      state.auctionBannersCount
  }
};
